import { render, staticRenderFns } from "./Aretouches.vue?vue&type=template&id=04f71bb8"
import script from "./Aretouches.vue?vue&type=script&lang=js"
export * from "./Aretouches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports